export default {
	labels: {
		general: {
			fall_detection: "Fall Detection",
			timeout_sos_state: "Timeout SOS State",
			timeout_turn_off_screen: "Timeout Turn Off Screen",
			offline_timer: "Offline timer",
			staff: "Staff",
			invitations: "Invitations",
			send_invitation: "Send Invitation",
			send: "Send",
			resend: "Resend",
			created: "Created",
			no_results: "No results found",
			organization: "Organization",
			email: "Email",
			url: "URL",
			billing_email: "Billing Email",
			use_policy: "Use Policy",
			privacy_policy: "Privacy Policy",
			terms_of_use: "Terms Of Use",
			rent_watches: "Rent watches",
			seats: "Seats",
			paid: "Paid",
			yearly: "Yearly",
			monthly: "Monthly",
			daily: "Daily",
			select: "Select",
			payment_frequency: "Payment Frequency",
			subscribe: "Subscribe",
			service: "Service",
			price_by_unit: "Price by unit",
			units: "Units",
			total: "Total",
			payment: "Payment",
			next_payment: "Next payment",
			auto_renew: "Auto-renew",
			empty: "Empty",
			view: "View",
			subscription: "Subscription",
			add_subscription: "Add subscription",
			transactions: "Transactions",
			transaction: "Transaction",
			service_period: "Service period",
			subtotal: "Subtotal",
			tax: "Tax",
			account_movement: "Account movement",
			logs: "Logs",
			message: "Message",
			amount: "Amount",
			operation: "Operation",
			slots: "Slots",
			in_use: "In use",
			available: "Available",
			add_payment_method: "Add payment method",
			current: "Current",
			active: "Active",
			set_active: "Set active",
			account: "Account",
			account_personal: "Personal account",
			my_idicare: "My IDICARE",
			timezone: "Timezone",
			subscriptions: "Subscriptions",
			budget: "Budget",
			resume: "Resume",
			account_movements: "Account movements",
			payment_methods: "Payment methods",
			birthdate: "Date of birth",
			birthday: "Birthday",
			blood_type: "Blood type",
			color: "Color",
			comments: "Comments",
			contact: "Contact",
			date: "Date",
			description: "Description",
			device_type: "Device type",
			device: "Device",
			disease: "Disease",
			dose: "Dose",
			end_date: "End date",
			end: "End",
			events: "Events",
			expire_date: "Expire date",
			feel: "Feel",
			first: "First",
			gender: "Gender",
			height: "Height",
			hour: "Hour",
			imei: "IMEI",
			in_use: "In use",
			insurance: "Insurance",
			last_sync: "Last sync",
			last: "Last",
			location: "Location",
			max: "Max",
			min: "Min",
			max_start: "Systolic start",
			max_end: "Systolic end",
			min_start: "Diastolic start",
			min_end: "Diastolic end",
			name: "Name",
			number: "Number",
			options: "Options",
			picture: "Picture",
			position: "Position",
			previous: "Previous",
			relation_contact: "Relation contact",
			relation: "Relation",
			shape: "Shape",
			start_date: "Start date",
			start: "Start",
			state: "State",
			status: "Status",
			today: "Today",
			type: "Type",
			uptime: "Uptime",
			value: "Value",
			week: "Week",
			weight: "Weight",
			years_old: "Years old",
			urgency: "Urgency",
			person: "Person",
			report: "Report",
			day: "Day",
			month: "Month",
			year: "Year",
			minute: "Minute",
			sos_phone: "SOS Phone",
			sync_interval_normal: "Sync Interval in Normal State",
			sync_interval_alert: "Sync Interval in Alert State",
			ok: "OK",
			sos: "SOS",
			false_positive: "False positive",
			no_response: "No Response",
			average: "Average",
			standard_deviation: "Standard deviation",
			samples: "Samples",
			systolic: "Systolic",
			diastolic: "Diastolic",
			fall: "Fall",
			responded: "Responded",
			not_responded: "Not responded",
			no_reports: "No reports",
			no_notifications: "No notifications",
		},
		auth: {
			fullname: "Full name",
			email: "Email",
			password: "Password",
			confirm_password: "Confirm password",
		},
		profile: {
			new_name: "New name",
			new_email: "New email",
			old_password: "Old password",
			new_password: "New password",
			confirm_new_password: "Confirm new password",
			personal_information: "Personal information",
			contacts: "Contacts",
			medical_information: "Medical information",
			family_information: "Family information",
			other_information: "Other information",
			social_numbers: "Social numbers",
			insurances: "Insurances",
		},
		alerts: {
			alert_value: "Value of {value} {units} from user {userName}",
			alert_value_falls: "{value} from user {userName}",
			alert_value_remove_title: "Watch Remove",
			alert_value_remove: "Patient {userName} removed watch from wrist",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/labels/labels_en-gb.js